import { CgArrowsExchange, CgTrashEmpty } from "react-icons/cg";
import {
  FaBars,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaRegMoneyBillAlt,
  FaTimes,
} from "react-icons/fa";
import { GoArrowDownLeft, GoArrowUpRight, GoDotFill } from "react-icons/go";
import {
  LuArrowDownLeft,
  LuArrowUpRight,
  LuBell,
  LuCalendar,
  LuCheck,
  LuHandCoins,
  LuTicket,
} from "react-icons/lu";
import {
  MdAirplanemodeActive,
  MdArrowForwardIos,
  MdCheck,
  MdClose,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdMoreVert,
  MdNotificationsNone,
  MdOutlineAirlines,
  MdOutlineClose,
} from "react-icons/md";

/**
 * Ícones usados pelo componente `Icon`, por biblioteca.
 * Importar só os ícones usados (e não `import * as`) permite ao bundler
 * descartar o resto das bibliotecas. Para usar um ícone novo, registre-o aqui.
 */
export const cgIcons = { CgArrowsExchange, CgTrashEmpty };
export const faIcons = {
  FaBars,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaRegMoneyBillAlt,
  FaTimes,
};
export const goIcons = { GoArrowDownLeft, GoArrowUpRight, GoDotFill };
export const luIcons = {
  LuArrowDownLeft,
  LuArrowUpRight,
  LuBell,
  LuCalendar,
  LuCheck,
  LuHandCoins,
  LuTicket,
};
export const mdIcons = {
  MdAirplanemodeActive,
  MdArrowForwardIos,
  MdCheck,
  MdClose,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdMoreVert,
  MdNotificationsNone,
  MdOutlineAirlines,
  MdOutlineClose,
};
